import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_not_found_view = _resolveComponent("not-found-view")!
  const _component_home_view = _resolveComponent("home-view")!

  return (_ctx.$route.name === '404')
    ? (_openBlock(), _createBlock(_component_not_found_view, { key: 0 }))
    : (_openBlock(), _createBlock(_component_home_view, { key: 1 }))
}